import { render, staticRenderFns } from "./UserDepartmentContainer.vue?vue&type=template&id=2a1d4c49&scoped=true&"
import script from "./UserDepartmentContainer.vue?vue&type=script&lang=js&"
export * from "./UserDepartmentContainer.vue?vue&type=script&lang=js&"
import style0 from "./UserDepartmentContainer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UserDepartmentContainer.vue?vue&type=style&index=1&id=2a1d4c49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1d4c49",
  null
  
)

export default component.exports